// components/sections/ContactInformation.tsx
import React from 'react';
import { Registry } from '@/graphql/__generated__/onboarding';
import TextSection from './TextSection';

interface ContactInformationProps {
	registry: Registry;
	onChangeRequest: (
		e: React.ChangeEvent<HTMLInputElement>,
		section: string,
		field: string,
		value: any
	) => void;
	changesRequested: Array<{ section: string; field: string; value: any }>;
	cantRequestChangesFromFields: string[];
}

export const ContactInformation: React.FC<ContactInformationProps> = ({
	registry,
	onChangeRequest,
	changesRequested,
	cantRequestChangesFromFields
}) => {
	return (
		<div className="space-y-3">
			<TextSection
				label="Email"
				value={registry.email}
				field="Email"
				sectionName="ContactInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="PhoneNumber"
				value={registry.phoneNumber}
				field="PhoneNumber"
				sectionName="ContactInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
		</div>
	);
};

export default ContactInformation;
